/**
 * 日時の見せ方（画面だけ。紙・API は使わない）。日本時間で出す（端末の時計の地域に左右されない＝receivedStamp と同じ）
 */
const JST = 9 * 3600 * 1000;
const pad = (n: number) => String(n).padStart(2, "0");

/**
 * 「10/11 19:40」（今年）・「2025/10/11 19:40」（違う年）。受け取った書類の「登録日時」（S3、../eigyouryoku/docs/13 §4.5 の 7）。
 * now はテスト用（省けば今）
 */
export function fmtDateTimeShort(iso: string, now: Date = new Date()): string {
  const d = new Date(new Date(iso).getTime() + JST);
  const y = new Date(now.getTime() + JST).getUTCFullYear();
  const md = `${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
  return d.getUTCFullYear() === y ? md : `${d.getUTCFullYear()}/${md}`;
}
